import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import AdminNavBar from '../../components/ui/AdminNavBar';
import MetricCard from './components/MetricCard';
import PrizeDistributionChart from './components/PrizeDistributionChart';
import EngagementTimelineChart from './components/EngagementTimelineChart';
import ParticipationTable from './components/ParticipationTable';
import FilterControls from './components/FilterControls';

const AnalyticsDashboard = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('all');
  const [selectedPrize, setSelectedPrize] = useState('all');
  const [selectedMode, setSelectedMode] = useState('all');

  const handleLogout = () => {
    window.location.href = '/roulette-game-screen';
  };

  const handleExportPDF = () => {
    console.log('Exportando reporte PDF...');
    alert('Funcionalidad de exportación PDF: En un entorno de producción, esto generaría un informe PDF completo con todas las métricas y gráficos.');
  };

  const handleExportCSV = () => {
    console.log('Exportando datos CSV...');
    alert('Funcionalidad de exportación CSV: En un entorno de producción, esto descargaría un archivo CSV con todos los datos de participación.');
  };

  const metricsData = [
    {
      title: 'Total Participaciones',
      value: '1,247',
      change: '+18.2%',
      changeType: 'positive',
      icon: 'Users',
      iconColor: 'var(--color-primary)',
      description: 'vs. evento anterior'
    },
    {
      title: 'Premios Entregados',
      value: '892',
      change: '+12.5%',
      changeType: 'positive',
      icon: 'Gift',
      iconColor: 'var(--color-success)',
      description: 'vs. evento anterior'
    },
    {
      title: 'Tasa de Conversión',
      value: '71.5%',
      change: '-2.3%',
      changeType: 'negative',
      icon: 'TrendingUp',
      iconColor: 'var(--color-warning)',
      description: 'vs. evento anterior'
    },
    {
      title: 'Tiempo Promedio',
      value: '3.2 min',
      change: '+0.5 min',
      changeType: 'neutral',
      icon: 'Clock',
      iconColor: 'var(--color-secondary)',
      description: 'por participación'
    }
  ];

  const prizeDistributionData = [
    { name: 'Descuento 20%', value: 312, percentage: 35 },
    { name: 'Muestra Gratis', value: 267, percentage: 30 },
    { name: 'Consulta Gratuita', value: 178, percentage: 20 },
    { name: 'Material Educativo', value: 135, percentage: 15 },
    { name: 'Sin Premio', value: 355, percentage: 28.5 }
  ];

  const engagementTimelineData = [
    { time: '09:00', participations: 45 },
    { time: '10:00', participations: 78 },
    { time: '11:00', participations: 125 },
    { time: '12:00', participations: 98 },
    { time: '13:00', participations: 67 },
    { time: '14:00', participations: 156 },
    { time: '15:00', participations: 189 },
    { time: '16:00', participations: 234 },
    { time: '17:00', participations: 178 },
    { time: '18:00', participations: 77 }
  ];

  const participationRecords = [
    {
      id: 1247,
      timestamp: '18/02/2026 16:35',
      prize: 'Descuento 20%',
      mode: 'Autónomo',
      participant: 'dr.martinez@hospital.es'
    },
    {
      id: 1246,
      timestamp: '18/02/2026 16:32',
      prize: 'Muestra Gratis',
      mode: 'Asistido',
      participant: 'Anónimo'
    },
    {
      id: 1245,
      timestamp: '18/02/2026 16:28',
      prize: 'Consulta Gratuita',
      mode: 'Autónomo',
      participant: 'dra.lopez@clinica.es'
    },
    {
      id: 1244,
      timestamp: '18/02/2026 16:25',
      prize: 'Sin Premio',
      mode: 'Autónomo',
      participant: 'Anónimo'
    },
    {
      id: 1243,
      timestamp: '18/02/2026 16:22',
      prize: 'Material Educativo',
      mode: 'Asistido',
      participant: 'dr.garcia@medico.es'
    },
    {
      id: 1242,
      timestamp: '18/02/2026 16:18',
      prize: 'Descuento 20%',
      mode: 'Autónomo',
      participant: 'Anónimo'
    },
    {
      id: 1241,
      timestamp: '18/02/2026 16:15',
      prize: 'Muestra Gratis',
      mode: 'Asistido',
      participant: 'dra.rodriguez@hospital.es'
    },
    {
      id: 1240,
      timestamp: '18/02/2026 16:12',
      prize: 'Consulta Gratuita',
      mode: 'Autónomo',
      participant: 'Anónimo'
    },
    {
      id: 1239,
      timestamp: '18/02/2026 16:08',
      prize: 'Descuento 20%',
      mode: 'Asistido',
      participant: 'dr.fernandez@clinica.es'
    },
    {
      id: 1238,
      timestamp: '18/02/2026 16:05',
      prize: 'Material Educativo',
      mode: 'Autónomo',
      participant: 'Anónimo'
    },
    {
      id: 1237,
      timestamp: '18/02/2026 16:02',
      prize: 'Sin Premio',
      mode: 'Autónomo',
      participant: 'dra.sanchez@hospital.es'
    },
    {
      id: 1236,
      timestamp: '18/02/2026 15:58',
      prize: 'Muestra Gratis',
      mode: 'Asistido',
      participant: 'Anónimo'
    },
    {
      id: 1235,
      timestamp: '18/02/2026 15:55',
      prize: 'Descuento 20%',
      mode: 'Autónomo',
      participant: 'dr.perez@medico.es'
    },
    {
      id: 1234,
      timestamp: '18/02/2026 15:52',
      prize: 'Consulta Gratuita',
      mode: 'Asistido',
      participant: 'Anónimo'
    },
    {
      id: 1233,
      timestamp: '18/02/2026 15:48',
      prize: 'Material Educativo',
      mode: 'Autónomo',
      participant: 'dra.gomez@clinica.es'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Panel de Análisis - XAIKUS Digital Roulette</title>
        <meta name="description" content="Panel de análisis y métricas de participación para eventos XAIKUS. Visualiza estadísticas en tiempo real, distribución de premios y genera reportes detallados." />
      </Helmet>
      <div className="min-h-screen bg-background">
        <AdminNavBar onLogout={handleLogout} />

        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
          <div className="mb-6 md:mb-8">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
              Panel de Análisis
            </h1>
            <p className="text-sm md:text-base text-muted-foreground">
              Métricas de participación y análisis de rendimiento del evento
            </p>
          </div>

          <div className="space-y-6 md:space-y-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {metricsData?.map((metric, index) => (
                <MetricCard key={index} {...metric} />
              ))}
            </div>

            <FilterControls
              selectedPeriod={selectedPeriod}
              onPeriodChange={setSelectedPeriod}
              selectedPrize={selectedPrize}
              onPrizeChange={setSelectedPrize}
              selectedMode={selectedMode}
              onModeChange={setSelectedMode}
              onExportPDF={handleExportPDF}
              onExportCSV={handleExportCSV}
            />

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
              <PrizeDistributionChart data={prizeDistributionData} />
              <EngagementTimelineChart data={engagementTimelineData} />
            </div>

            <ParticipationTable data={participationRecords} />
          </div>
        </main>
      </div>
    </>
  );
};

export default AnalyticsDashboard;